import i18n from 'services/base/i18n';

export default {
  // The OK button to accept the changes to weekday selection
  ok: () => i18n.pgettext('Components|Parental Controls|Schedule Days', 'OK'),

  // The button to mark all days as 'checked'
  checkAll: () => i18n.pgettext('Components|Parental Controls|Schedule Days', 'Select All'),

  // The button to mark all days as 'unchecked'
  uncheckAll: () => i18n.pgettext('Components|Parental Controls|Schedule Days', 'Unselect All'),
};
